import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ClipboardList, X } from "lucide-react";
import { api, arabicError } from "../lib/api";
import OrderDetail, { StatusPill } from "../components/store/OrderDetail";

const TABS = [["all", "الكل"], ["pending", "بانتظار التأكيد"], ["confirmed", "مؤكد / محجوز"], ["completed", "مكتمل"], ["rejected", "مرفوض"]];

export default function StoreOrders() {
  const [data, setData] = useState({ items: [], counts: {}, actor: null });
  const [tab, setTab] = useState("all");
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useSearchParams();
  const selectedId = params.get("o");
  const selected = data.items.find((o) => o.id === selectedId) || null;

  const load = () => api.get("/store-orders").then((r) => setData(r.data)).catch((e) => toast.error(arabicError(e))).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const visible = tab === "all" ? data.items : data.items.filter((o) => o.status === tab);
  const select = (id) => setParams(id ? { o: id } : {});
  const onChanged = (o) => setData((d) => ({ ...d, items: d.items.map((x) => (x.id === o.id ? o : x)) }));

  return (
    <div className="space-y-6" data-testid="store-orders-page">
      <div>
        <h1 className="text-3xl font-extrabold text-[#333333] flex items-center gap-2"><ClipboardList className="text-[#09637E]" /> طلبات المتجر العام</h1>
        <p className="text-[#666666] mt-1 text-sm">طلبات الزبائن من متجرك العام: «تأكيد الطلب» يحجز الكمية معلوماتياً فقط، و«إتمام البيع» يُسجّل البيع ويخصم المخزون ويُنشئ الفاتورة.</p>
      </div>

      <div className="flex flex-wrap gap-2" data-testid="store-orders-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`orders-tab-${k}`}
            className={`h-10 px-4 rounded-lg font-bold text-sm border-2 ${tab === k ? "bg-[#09637E] border-[#09637E] text-white" : "border-[#7AB2B2] text-[#09637E] bg-white"}`}>
            {l} <span className="text-xs opacity-80" dir="ltr">({k === "all" ? data.items.length : data.counts[k] || 0})</span>
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <div className={`lg:col-span-2 bg-white border border-[#7AB2B2] rounded-xl overflow-hidden ${selected ? "hidden lg:block" : ""}`} data-testid="store-orders-list">
          {loading ? <div className="p-8 text-center text-[#666666]">جارٍ التحميل...</div> : visible.length === 0 ? (
            <div className="p-10 text-center text-[#666666]" data-testid="store-orders-empty">لا توجد طلبات</div>
          ) : visible.map((o) => (
            <button key={o.id} type="button" onClick={() => select(o.id)} data-testid={`order-row-${o.id}`}
              className={`w-full text-right p-4 border-b border-[#EBF4F6] last:border-0 hover:bg-[#F7FBFC] ${selected?.id === o.id ? "bg-[#EBF4F6]" : ""}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="font-extrabold text-[#333333]" dir="ltr">{o.reference}</span>
                <StatusPill o={o} />
              </div>
              <div className="text-sm text-[#333333] mt-1 font-bold truncate">{o.customer?.name} · <span dir="ltr">{o.customer?.phone}</span></div>
              <div className="text-xs text-[#666666] mt-0.5 flex flex-wrap gap-x-2">
                <span>{o.fulfillment_method === "pickup" ? "استلام" : "توصيل"}</span><span>· {o.items.length} صنف</span><span>· {o.payment_method_ar}</span><span>· {new Date(o.created_at).toLocaleString("ar-SY")}</span>
              </div>
              <div className="text-[#09637E] font-extrabold mt-1 tabular-nums" dir="ltr">${Number(o.total).toFixed(2)}</div>
            </button>
          ))}
        </div>
        <div className="lg:col-span-3">
          {selected ? (
            <div className="bg-white border border-[#7AB2B2] rounded-xl p-4">
              <button type="button" onClick={() => select(null)} className="lg:hidden mb-3 text-sm text-[#666666] flex items-center gap-1" data-testid="order-back"><X size={14} /> رجوع للقائمة</button>
              <OrderDetail order={selected} onChanged={onChanged} />
            </div>
          ) : (
            <div className="hidden lg:flex bg-white border border-dashed border-[#7AB2B2] rounded-xl p-10 text-center text-[#666666] items-center justify-center h-full" data-testid="store-orders-placeholder">اختر طلباً لعرض التفاصيل</div>
          )}
        </div>
      </div>
    </div>
  );
}
